/** Host that overrides the project/feature-flag logo with its own brand. */
const SWISSRE_HOST = 'swissre.yukkalab.com';

/**
 * Brand logo id for the current host. The SwissRe host always uses its own
 * logo; every other host uses the provided default (the project logo, or the
 * feature-flag logo for the post-login menu headers).
 *
 * Replaces the `window.location.hostname === 'swissre.yukkalab.com'` check that
 * was duplicated across login/password/message + the menu-above headers.
 */
export function resolveLogo(defaultLogo: string): string {
  return window.location.hostname === SWISSRE_HOST ? 'swissre' : defaultLogo;
}
